"use client";

import { CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const faqs = [{
    id: "item-1",
    question: "What types of events do you DJ?",
    answer: "I specialize in weddings and private events throughout the Denver area. From intimate ceremonies to grand receptions, I tailor every playlist, lighting setup, and audio experience to match your unique vision and make your special day come to life exactly as it deserves."
  }, {
    id: "item-2",
    question: "How far in advance should I book your services?",
    answer: "I recommend booking at least 6-12 months in advance, especially for peak wedding season (May through October). However, I do my best to accommodate last-minute requests whenever possible. Contact me as soon as you have a date in mind to ensure availability."
  }, {
    id: "item-3",
    question: "Do you provide sound and lighting equipment?",
    answer: "Yes! I bring professional-grade AV sound equipment and event lighting design to every celebration. My setups are customized to your venue size and ambiance preferences, ensuring crystal-clear audio and the perfect mood lighting for your event."
  }, {
    id: "item-4",
    question: "Can I request specific songs or genres?",
    answer: "Absolutely. Your event, your music. I work closely with you to create a customized playlist that reflects your style and keeps your guests dancing. Whether you want classic hits, current chart-toppers, or a mix of genres, I'll curate the perfect soundtrack."
  }, {
    id: "item-5",
    question: "What is your pricing structure?",
    answer: "Pricing varies based on event duration, equipment needs, and additional services like lighting design or ceremony sound. I offer transparent, competitive rates with no hidden fees. Reach out for a personalized quote tailored to your event's requirements."
  }, {
    id: "item-6",
    question: "Do you offer consultations before the event?",
    answer: "Yes, I provide complimentary consultations to discuss your vision, timeline, and any special requests. This ensures seamless event coordination and allows us to plan every detail—from grand entrances to last-dance moments—so your celebration unfolds flawlessly."
  }];
  return <section id="frequently-asked-questions" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Get answers to common questions about my DJ and AV services in Denver.
          </p>
        </div>

        <div ref={ref} className="space-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateX(0)" : "translateX(-2rem)"
      }}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border bg-background hover:shadow-soft mb-2 rounded-lg border px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <AccordionTrigger className="group text-left hover:no-underline">
                  <div className="flex items-start gap-4">
                    <CircleQuestionMark className="text-primary group-data-[state=open]:rotate-180 mt-0.5 size-5 shrink-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
                    <span className="text-foreground font-semibold">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pl-9">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}